import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../../../Components/ButtonCustom';
import { Tooltip } from 'antd/lib';

interface PropsAcaoSalvar {
    salvarPontosSelecionados: Function
    /** Quantos pontos estão marcados no mapa e ainda não viraram análise. */
    total_pontos_selecionados: number
    /** Quantas análises já foram adicionadas via "Adicionar análise". */
    total_analises_adicionadas: number
    /** Em tela cheia é preciso sair do fullscreen antes de salvar, pois salvar fecha o modal. */
    sairDoFullscreen?: () => void
}

/**
 * Botão de salvar a análise, único para os dois layouts.
 *
 * `salvarPontosSelecionados` fecha o modal ao final. Em tela cheia isso desmontaria o
 * elemento que está em fullscreen, deixando o navegador em tela cheia sobre um nó
 * removido — por isso saímos do fullscreen antes de salvar, e não depois.
 *
 * Salvar só persiste o que está em "Pontos adicionados": pontos apenas marcados no mapa
 * são descartados. Por isso o botão fica desabilitado tanto quando nada foi adicionado
 * como quando sobrou uma seleção pendente — sem isso o usuário fecharia o modal achando
 * que salvou os pontos que estava vendo selecionados.
 */
export const AcaoSalvar: React.FC<PropsAcaoSalvar> = ({ salvarPontosSelecionados, sairDoFullscreen,
    total_pontos_selecionados, total_analises_adicionadas
}) => {

    const selecao_pendente = total_pontos_selecionados > 0
    const nada_adicionado = total_analises_adicionadas === 0

    const motivo_bloqueio = selecao_pendente
        ? 'Você tem pontos selecionados que ainda não foram adicionados. Clique em "Adicionar análise" ou limpe a seleção.'
        : nada_adicionado
            ? 'Selecione os pontos no mapa e clique em "Adicionar análise" antes de salvar.'
            : undefined

    function salvar() {
        sairDoFullscreen?.()
        salvarPontosSelecionados()
    }

    return (
        <Tooltip title={!!motivo_bloqueio ? motivo_bloqueio : ''}><span>
            <ButtonCustom
                onClick={salvar}
                disabled={!!motivo_bloqueio}
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            >
                Salvar análise
            </ButtonCustom>
        </span></Tooltip>
    )
}
